import { render, staticRenderFns } from "./tasks-list.vue?vue&type=template&id=76b1e80e"
import script from "./tasks-list.vue?vue&type=script&lang=js"
export * from "./tasks-list.vue?vue&type=script&lang=js"
import style0 from "./tasks-list.vue?vue&type=style&index=0&id=76b1e80e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports